<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12" md="6">
        <v-card :loading="loading" class="my-6">
          <template slot="progress">
            <v-progress-linear height="10" indeterminate></v-progress-linear>
          </template>
            <template>
                <v-card-title>Total Card Summary</v-card-title>

                <v-simple-table dense>
                    <template v-slot:default>
                        <tbody>
                        <tr>
                            <td>Active Card</td>
                            <td>{{ card_info.activeCard }}</td>
                        </tr>
                        <tr>
                            <td>Inactive Card</td>
                            <td>{{ card_info.inactiveCard }}</td>
                        </tr>
                        <tr>
                            <td>Total Card</td>
                            <td>{{ card_info.totalCard }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </template>
            <template>
                <v-card-title>Total Assign Card Summary</v-card-title>

                <v-simple-table dense>
                    <template v-slot:default>
                        <tbody>
                        <tr>
                            <td>Assign Card</td>
                            <td>{{ card_info.assignCard }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </template>
            <template>
                <v-card-title>Total Service Patient</v-card-title>

                <v-simple-table dense>
                    <template v-slot:default>
                        <tbody>
                        <tr>
                            <td>Total Invoice</td>
                            <td>{{ card_info.service_patient }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </template>
          <v-divider class="mx-4"></v-divider>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card :loading="loading" class="my-6">
          <template slot="progress">
            <v-progress-linear height="10" indeterminate></v-progress-linear>
          </template>
          <template>
            <v-card-title>Card Type</v-card-title>
            <v-data-table
              :headers="card_type_headers"
              :items="card_type_desserts"
              class="elevation-1"
              :search="search"
              dense
              disable-pagination
              :loading="loading"
            >
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
              </template>
            </v-data-table>
          </template>
          <v-divider class="mx-4"></v-divider>
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>
            Employee List
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="desserts"
            class="elevation-1"
          >
          </v-data-table>

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <template>
          <div class="text-center">
            <v-dialog v-model="cardSummaryDialog" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
                  Card Summary
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                  Card Summary
                </v-card-title>

                <v-col v-for="(dateRange, n) in cardSummaryData" :key="n">
                  <v-alert type="success">{{ dateRange.title }}</v-alert>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>Qty</th>
                          <th>Cash Back</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in dateRange.data" :key="i">
                          <td>{{ item.invoice_type }}</td>
                          <td>{{ item.qty }}</td>
                          <td>{{ item.total_cashback_amount }}</td>
                          <td>{{ item.total_paid_amount }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider
                ></v-col>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="warning"
                    text
                    @click="cardSummaryDialog = false"
                  >
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
      </v-col>
    </v-row>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
              Add New Card
            </v-btn>
          </template> -->
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Add New Card
            </v-card-title>
            <v-text-field
              label="Card Number"
              v-model="new_card_no"
              outlined
              dense
            ></v-text-field>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="submitForm()"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>
 
<style scoped></style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      card_no: this.$route.params.id,
      new_card_no: null,
      search: "",
      cardSummaryDialog: false,
      cardSummaryData: [],
      dialog: false,
      loading: true,
      desserts: [],
      headers: [
        { text: "Employee Name", value: "assign_to.full_name" },
        { text: "Assign Card", value: "assignCard" },
        { text: "Active Card", value: "activeCard" },
        // { text: "Total Card", value: "totalCard" },
      ],
      card_type_desserts: [],
      card_type_headers: [
        { text: "Card Type", value: "card_type.name" },
        { text: "Total Card", value: "total" },
      ],
      patient_info: {},
      errors: "",
      card_info: {
        name: "",
      },
      referral_info: {
        corporate_client: {
          ps_name: "-",
        },
      },
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },

        {
          text: "Card",
          disabled: true,
          href: "patient-details",
        },
      ],
    };
  },

  // Fetches posts when the component is created.

  created() {
    this.initialize();
    this.cardSummary();
  },
  methods: {
    initialize() {
      atshq
        .get("card/dashboard")
        .then((response) => {
          this.loading = false;
          // JSON responses are automatically parsed.

          this.card_info = response.data.data;
          this.desserts = response.data.data.empData;
          this.card_type_desserts = response.data.data.cardSummary;
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log(e);
        });
    },
    
    cardSummary() {
      atshq
        .get("card/summary")
        .then((response) => {
          this.loading = false;
          // JSON responses are automatically parsed.

          this.cardSummaryData = response.data.data;
          console.log(this.cardSummaryData);
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log(e);
        });
    },
    submitForm() {
      if (this.invoice_total < this.subtotal) {
        alert("Please wait for further invoices against this patient.");
        return false;
      }
      if (this.new_card_no == null) {
        alert("Please input valid card No.");
        return false;
      }

      if (confirm("are you sure?"))
        atshq
          .post("card/card", {
            formdata: this.new_card_no,
            user_id: localStorage.getItem("userId"),
          })
          .then((res) => {
            //Perform Success Action
            if (res.status == "200") {
              this.$noty.success("Successfully saved.");
              this.dialog = false;
            }
          })
          .catch((e) => {
            this.$noty.error("Oops, something went wrong!");

            this.errors.push(e);
          })
          .finally(() => {
            //Perform action in always
          });
    },
    editItem(item) {
      window.location.href = "/patient-create/" + item.patient_id;
    },
    viewItem(item) {
      window.location.href = "/patient-details/" + item.patient_id;
    },
    visionTherapy(item) {
      window.location.href = "/services/vision-therapy/" + item.patient_id;
    },
  },
};
</script>